/* Sitewide "Select options" quick-view popup — the modal markup lives in
   snippets/editorial-quickview-modal.liquid, rendered once globally by
   layout/theme.liquid. Any [data-ed-quickview-trigger] element on any page
   (editorial rows, UGC tiles, old-theme product cards, ...) opens it; product
   data is fetched live from /products/{handle}.js rather than requiring each
   page to embed it in advance. */
(function () {
  function money(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'PKR', currencyDisplay: 'narrowSymbol' });
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = 'Cart (' + cart.item_count + ')';
        });
      })
      .catch(function () {});
  }

  function stripHtml(html) {
    var div = document.createElement('div');
    div.innerHTML = html || '';
    var text = (div.textContent || '').replace(/\s+/g, ' ').trim();
    return text.length > 160 ? text.slice(0, 160).trim() + '…' : text;
  }

  function withWidth(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.querySelector('[data-ed-quickview]');
    if (!modal) return;

    var productCache = {};

    var qvImg = modal.querySelector('[data-ed-quickview-img]');
    var qvTitle = modal.querySelector('[data-ed-quickview-title]');
    var qvPrice = modal.querySelector('[data-ed-quickview-price]');
    var qvCompare = modal.querySelector('[data-ed-quickview-compare]');
    var qvSale = modal.querySelector('[data-ed-quickview-sale]');
    var qvDesc = modal.querySelector('[data-ed-quickview-desc]');
    var qvLink = modal.querySelector('[data-ed-quickview-link]');
    var qvStock = modal.querySelector('[data-ed-quickview-stock]');
    var qvStockText = modal.querySelector('[data-ed-quickview-stock-text]');
    var qvSizes = modal.querySelector('[data-ed-quickview-sizes]');
    var qvQty = modal.querySelector('[data-ed-quickview-qty]');
    var qvQtyMinus = modal.querySelector('[data-ed-quickview-qty-minus]');
    var qvQtyPlus = modal.querySelector('[data-ed-quickview-qty-plus]');
    var qvAdd = modal.querySelector('[data-ed-quickview-add]');
    var qvBuy = modal.querySelector('[data-ed-quickview-buy]');
    var qvClose = modal.querySelector('[data-ed-quickview-close]');
    var qvToast = modal.querySelector('[data-ed-quickview-toast]');
    var qvToastTimer = null;

    var currentVariant = null;

    function showToast(message) {
      if (!qvToast) return;
      qvToast.textContent = message;
      qvToast.hidden = false;
      clearTimeout(qvToastTimer);
      qvToastTimer = setTimeout(function () { qvToast.hidden = true; }, 3200);
    }

    function selectVariant(variant) {
      currentVariant = variant;
      qvPrice.textContent = money(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      qvCompare.hidden = !onSale;
      qvSale.hidden = !onSale;
      if (onSale) qvCompare.textContent = money(variant.compare_at_price);

      qvStockText.textContent = variant.available ? 'In Stock' : 'Sold out';
      qvStock.classList.toggle('is-out', !variant.available);
      qvAdd.disabled = !variant.available;
      qvBuy.disabled = !variant.available;
      qvAdd.textContent = variant.available ? 'Add to cart' : 'Sold out';

      qvSizes.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-selected', b.getAttribute('data-value') === variant.option1);
      });
    }

    function renderProduct(product) {
      qvImg.src = withWidth(product.featured_image, 1200);
      qvTitle.textContent = product.title;
      qvDesc.textContent = stripHtml(product.description);
      qvLink.href = product.url;
      qvQty.value = 1;

      qvSizes.innerHTML = '';
      var seen = {};
      var multipleOptions = false;
      product.variants.forEach(function (v) {
        if (seen[v.option1]) return;
        seen[v.option1] = true;
        if (product.variants.length > 1) multipleOptions = true;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = v.option1;
        btn.setAttribute('data-value', v.option1);
        btn.addEventListener('click', function () { selectVariant(v); });
        qvSizes.appendChild(btn);
      });
      qvSizes.hidden = !multipleOptions;

      var firstAvailable = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
      selectVariant(firstAvailable);

      modal.hidden = false;
      document.documentElement.setAttribute('data-ed-modal-open', 'true');
    }

    function openQuickview(handle) {
      if (!handle) return;
      if (productCache[handle]) {
        renderProduct(productCache[handle]);
        return;
      }
      fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('Product not found');
          return r.json();
        })
        .then(function (product) {
          productCache[handle] = product;
          renderProduct(product);
        })
        .catch(function () {});
    }

    function closeQuickview() {
      modal.hidden = true;
      document.documentElement.removeAttribute('data-ed-modal-open');
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest ? e.target.closest('[data-ed-quickview-trigger]') : null;
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      openQuickview(trigger.getAttribute('data-ed-product-handle'));
    });

    if (qvClose) qvClose.addEventListener('click', closeQuickview);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeQuickview(); });
    window.addEventListener('keydown', function (e) {
      if (!modal.hidden && e.key === 'Escape') closeQuickview();
    });

    if (qvQtyMinus) {
      qvQtyMinus.addEventListener('click', function () {
        qvQty.value = Math.max(1, (parseInt(qvQty.value, 10) || 1) - 1);
      });
    }
    if (qvQtyPlus) {
      qvQtyPlus.addEventListener('click', function () {
        qvQty.value = (parseInt(qvQty.value, 10) || 1) + 1;
      });
    }

    function addCurrentToCart() {
      if (!currentVariant) return Promise.reject(new Error('No variant selected'));
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: currentVariant.id, quantity: parseInt(qvQty.value, 10) || 1 })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
        return r.json();
      });
    }

    if (qvAdd) {
      qvAdd.addEventListener('click', function () {
        qvAdd.disabled = true;
        addCurrentToCart()
          .then(function () {
            showToast('Added to cart.');
            updateCartCount();
          })
          .catch(function (err) { showToast(err.message || 'Could not add to cart.'); })
          .finally(function () { qvAdd.disabled = !(currentVariant && currentVariant.available); });
      });
    }

    if (qvBuy) {
      qvBuy.addEventListener('click', function () {
        qvBuy.disabled = true;
        addCurrentToCart()
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) {
            showToast(err.message || 'Could not check out.');
            qvBuy.disabled = !(currentVariant && currentVariant.available);
          });
      });
    }
  });
})();
